import { StaticImage } from "gatsby-plugin-image"

import { checkCircleIcon } from "@trueskin-web/theme/icons/checkCircleIcon"
import { crossCircleIcon } from "@trueskin-web/theme/icons/crossCircleIcon"
import { shineIcon } from "@trueskin-web/theme/icons/shineIcon"
import { shippingIcon } from "@trueskin-web/theme/icons/shippingIcon"

import deliveryIcon from "./images/deliveryIcon.svg"
import euroIcon from "./images/euroIcon.svg"
import refillIcon from "./images/refillIcon.svg"
import sealIcon from "./images/sealIcon.svg"

const data = {
  products: [
    {
      title: "Deine personalisierte Formel",
      description: "Von Ärzt:innen entwickelt, um Deine Haut zu verbessern",
      image: ({ className }) => (
        <StaticImage
          src="../../../../images/rebranded/two-month-package/2m-package-slider_slide3.png"
          alt=""
          height={56}
          className={className}
        />
      ),
      details: {
        title: "Deine Formel",
        slides: [
          ({ className }) => (
            <StaticImage
              src="../../../../images/rebranded/rebranded-formula-01.png"
              alt=""
              objectFit="contain"
              objectPosition="center center"
              className={className}
            />
          ),
          ({ className }) => (
            <StaticImage
              src="../../../../images/rebranded/rebranded-formula-ingredient.png"
              alt=""
              objectFit="cover"
              objectPosition="center center"
              className={className}
            />
          ),
        ],
        primaryColor: "primary",
        secondaryColor: "lightGreen",
        callout: {
          title: "Für sichtbar bessere Haut",
          description:
            "<p>Deine Formel wird extra von unserem Ärzt:innen-Team für Dich zusammengestellt. Alle Inhaltsstoffe und deren Dosierung sind so gewählt, dass sie Deine Haut schnellstmöglich verbessern.</p><p>Die finale Zusammensetzung teilen wir Dir mit, nachdem Dein:e FORMEL SKIN-Ärzt:in Deine Fotos ausgewertet und Deine Hautanalyse abgeschlossen hat.</p><p>Das Beste: Wenn sich Deine Haut während der Behandlung ändert, passen wir die Zusammensetzung Deiner Formel an. So erhältst Du immer das Produkt von uns, das perfekt zu Deiner Haut passt.</p>",
          textColor: "background",
        },
        sections: [
          {
            title: "Unsere effektivsten Wirkstoffe:",
            description:
              "Diese Wirkstoffe könnte Deine Formel enthalten. Die finale Zusammensetzung bestimmen unsere Ärzt:innen.",
          },
        ],
        ingredients: [
          {
            title: "Tretinoin",
            image: ({ className }) => (
              <StaticImage
                src="./images/tretinoin.webp"
                alt=""
                className={className}
              />
            ),
            lines: [
              "Beschleunigt die Zellerneuerung",
              "Wirkt komedolytisch (Mitesser auflösend)",
            ],
          },
          {
            title: "Niacinamide",
            image: ({ className }) => (
              <StaticImage
                src="./images/niacinamide.webp"
                alt=""
                className={className}
              />
            ),
            lines: [
              "Ist eine Form des Vitamin B",
              "Stärkt die Hautbarriere",
              "Verfeinert das Hautbild",
            ],
          },
          {
            title: "Benzoylperoxid",
            image: ({ className }) => (
              <StaticImage
                src="./images/benzoylperoxid.webp"
                alt=""
                className={className}
              />
            ),
            lines: [
              "Wirkt antibakteriell",
              "Wirkt komedolytisch (Mitesser auflösend)",
            ],
          },
          {
            title: "Azelainsäure",
            image: ({ className }) => (
              <StaticImage
                src="./images/azelainsaure.webp"
                alt=""
                className={className}
              />
            ),
            lines: [
              "Wirkt entzündungshemmend",
              "Reduziert Pigmentflecken und Pickelmale",
            ],
          },
          {
            title: "Clindamycin",
            image: ({ className }) => (
              <StaticImage
                src="./images/clindamycin.webp"
                alt=""
                className={className}
              />
            ),
            lines: [
              "Ist ein topisches Antibiotikum",
              "Hemmt akneauslösende Bakterien",
            ],
          },
          {
            title: "Erythromycin",
            image: ({ className }) => (
              <StaticImage
                src="./images/erythromycin.webp"
                alt=""
                className={className}
              />
            ),
            lines: [
              "Wirkt anti-bakteriell und anti-entzündlich",
              "Wird u. a. bei perioraler Dermatitis eingesetzt",
            ],
          },
        ],
      },
    },
    {
      title: "Die Reinigung",
      description: "Bereitet Deine Haut optimal auf Deine Formel vor",
      image: ({ className }) => (
        <StaticImage
          src="../../../../images/rebranded/two-month-package/2m-package-slider_slide5.png"
          alt=""
          height={56}
          className={className}
        />
      ),
      details: {
        title: "Deine Reinigung",
        slides: [
          ({ className }) => (
            <StaticImage
              src="../../../../images/rebranded/rebranded-cleanser-01.png"
              alt=""
              objectFit="contain"
              objectPosition="center center"
              className={className}
            />
          ),
          ({ className }) => (
            <StaticImage
              src="../../../../images/rebranded/rebranded-cleanser-ingredient.png"
              alt=""
              objectFit="cover"
              objectPosition="center center"
              className={className}
            />
          ),
        ],
        primaryColor: "blue",
        secondaryColor: "lightBlue",
        callout: {
          title: "Als perfekte Unterstützung",
          description:
            "Das FORMEL SKIN-Reinigungsgel bereitet Deine Haut optimal auf die Wirkstoffe Deiner Formel vor.",
          textColor: "text",
        },
        sections: [
          {
            title: "Das Reinigungsgel",
            description:
              "<p>Das Reinigungsgel befreit Deine Haut gründlich von überschüssigem Talg, Schmutz und Make-up, ohne sie auszutrocknen. </p> <p>Die entzündungshemmende Kombination aus Salicylsäure und Panthenol reguliert die Talgproduktion und reduziert Mitesser sichtbar. Gleichzeitig verfeinert Salicylsäure das Hautbild, minimiert Poren und wirkt gegen Unreinheiten, sodass Dein Teint ebenmäßiger und strahlender erscheint. Panthenol und Aloe Vera beruhigen Deine Haut, spenden intensiv Feuchtigkeit und unterstützen die natürliche Hautbarriere – für ein frisches und ausgeglichenes Hautgefühl.</p>",
          },
        ],
      },
    },
    {
      title: "Die Pflege",
      description: "Beruhigt Deine Haut und spendet nötige Feuchtigkeit",
      image: ({ className }) => (
        <StaticImage
          src="../../../../images/rebranded/two-month-package/2m-package-slider_slide4.png"
          alt=""
          height={56}
          className={className}
        />
      ),
      details: {
        title: "Deine Pflege",
        slides: [
          ({ className }) => (
            <StaticImage
              src="../../../../images/rebranded/rebranded-moisturizer-01.png"
              alt=""
              objectFit="contain"
              objectPosition="center center"
              className={className}
            />
          ),
          ({ className }) => (
            <StaticImage
              src="../../../../images/rebranded/rebranded-moisturizer-02.png"
              alt=""
              objectFit="contain"
              objectPosition="center center"
              className={className}
            />
          ),
          ({ className }) => (
            <StaticImage
              src="../../../../images/rebranded/rebranded-moisturizer-ingredient.png"
              alt=""
              objectFit="cover"
              objectPosition="center center"
              className={className}
            />
          ),
        ],
        primaryColor: "darkRose",
        secondaryColor: "hsla(344, 69%, 97%, 1)",
        callout: {
          title: "Für optimale Feuchtigkeit",
          description:
            "Je nach Hauttyp und medizinischer Behandlung wählen wir die passende Feuchtigkeitspflege für Dich aus. Sie wird Deine Haut hydratisiert halten und Deine tägliche Skin-Care-Routine abrunden. ",
          textColor: "text",
        },
        sections: [
          {
            title: "Die leichte Pflege",
            description:
              "Du wünschst Dir eine zarte Feuchtigkeitscreme, die Deine Haut hydratisiert und ein geschmeidiges Hautgefühl hinterlässt? Unsere leichte Pflege wurde speziell für ölige und zu Akne neigende Hauttypen entwickelt – aber auch normale und Mischhaut profitieren vondieser leichten Pflegecreme.",
          },
          {
            title: "Die reichhaltige Pflege",
            description:
              "Du wünscht Dir eine Pflege mit langanhaltender hydratisierender Wirkung? Die reichhaltige Pflege wurde speziell für trockene Haut entwickelt. Doch auch wenn Du von Natur aus keine trockene Haut hast, könnte sie während Deiner Behandlung die richtige Wahl für Dich sein. Denn sie kann den Begleiterscheinungen mancher Formel-Wirkstoffe (z. B. Trockenheit, Rötungen und Reizungen) vorbeugen oder entgegenwirken. ",
          },
        ],
      },
    },
  ],
  v1: {
    plans: {
      sub_bimonthly: {
        title: "2-Monats-Set",
        details: [
          {
            content:
              "Bequeme automatische Lieferung alle 2 Monate (XX € für 2 Monate)",
          },
          {
            content:
              "Du entscheidest: pausiere, verschiebe, oder kündige jederzeit",
          },
        ],
        footnote:
          "91 % unserer Patient:innen nutzen dieses Set für beste Ergebnisse",
      },
      sub_one_month: {
        title: "1-Monats-Set",
        details: [
          {
            content: "Monatliche automatische Lieferung",
          },
          {
            content:
              "Du entscheidest: pausiere, verschiebe, oder kündige jederzeit",
          },
        ],
      },
      single_purchase: {
        title: "Einmalkauf",
        description: "Einmalige Lieferung",
        details: [
          {
            content: "Erhalte einmalig ein personalisiertes FORMEL SKIN-Set ",
            icon: checkCircleIcon,
            theme: "primary",
          },
          {
            content: "Keine laufenden Anpassungen Deiner Formel",
            icon: crossCircleIcon,
            theme: "rose",
          },
          {
            content:
              "Keine fortlaufende ärztliche Betreuung zur Verbesserung Deiner Haut",
            icon: crossCircleIcon,
            theme: "rose",
          },
        ],
      },
      prescription: {
        title: "Rezept",
        description: "+ca. 35 € Apothekengebühren",
        details: [
          {
            content:
              "Erhalte ein Privatrezept, keine Zulieferung vom FORMEL SKIN-Set",
            icon: crossCircleIcon,
            theme: "rose",
          },
          {
            content:
              "Keine fortlaufende ärztliche Betreuung & keine Anpassungen Deiner Formel",
            icon: crossCircleIcon,
            theme: "rose",
          },
          {
            content:
              "Ca. 35 € zusätzliche Herstellungskosten in der Apotheke und Wartezeit",
            icon: crossCircleIcon,
            theme: "rose",
          },
        ],
      },
    },
    subscription: {
      title: "Fortlaufende Behandlung, bis Du Dein Hautziel erreicht hast",
      details: [
        "Jederzeit ärztliche Beratung",
        "Regelmäßige Analyse Deiner Haut und Anpassungen Deiner Formel",
        "Kostenlose Lieferung zu Dir nach Hause ",
      ],
    },
    faq: [
      {
        icon: refillIcon,
        question: "Wie funktioniert die automatische Lieferung?",
        answer: (
          <>
            <p>
              Deine Haut durchläuft ständig Veränderungen. Daher erhältst Du bei
              unserer automatischen Lieferung (zwei-)monatlich ein neues FORMEL
              SKIN-Set. Zuvor hast Du die Möglichkeit, online einen Check-in
              durchzuführen, bei dem Deine Ärztin/Dein Arzt{" "}
              <span sx={{ fontWeight: "bold" }}>
                die Fortschritte Deiner Haut überprüft und Deine Formel bei
                Bedarf anpasst.
              </span>
            </p>
            <p>
              Dir passt der nächste Lieferzeitpunkt nicht? Kein Problem! In
              unserem Kund:innenbereich hast Du die Möglichkeit, Deine nächste
              Lieferung auf Deine Bedürfnisse anzupassen.
            </p>
          </>
        ),
      },
      {
        icon: deliveryIcon,
        question: "Für welche Lieferfrequenz soll ich mich entscheiden?",
        answer: (
          <>
            <p>
              Deine Lieferfrequenz kannst Du ganz nach Deiner persönlichen
              Präferenz wählen.
            </p>
            <p>
              Die meisten unserer Patient:innen entscheiden sich für das
              praktische 2-Monats-Set mit dem größten Preisvorteil. Du möchtest
              ebenfalls das beste Preis-Leistungs-Verhältnis und Deine Hautziele
              zu einem möglichst niedrigen Preis erreichen? Dann entscheide auch
              Du Dich für das 2-Monats-Set. Du möchtest maximale Flexibilität?
              Dann wähle das 1-Monats-Set.
            </p>
            <p>
              Egal für welche Option Du Dich entscheidest: Du kannst Deine
              Lieferung jederzeit kündigen, pausieren oder anpassen.
            </p>
          </>
        ),
      },
      {
        icon: euroIcon,
        question: "Wie funktioniert die Geld-zurück-Garantie?",
        answer: (
          <>
            <p>
              Sollte Deine Behandlung keine Fortschritte bringen, bieten wir
              unter bestimmten Bedingungen eine Geld-zurück-Garantie an:
            </p>
            <p>
              Verwendungsdauer: Du hast unsere Akne-Produkte mindestens 60 und
              maximal 90 Tage konsequent angewendet. Ergebnisse sind in der
              Regel nach 6–8 Wochen sichtbar, spätestens jedoch nach 90 Tagen.
            </p>
            <p>
              Anwendung: Du hast die Wirkstoff-Formel regelmäßig und wie
              empfohlen verwendet und mindestens einen ärztlichen Check-in
              wahrgenommen, um gegebenenfalls Anpassungen an der Formel
              vornehmen zu lassen.
            </p>
            <p>
              Solltest Du nach diesem Zeitraum und trotz Anpassungen weiterhin
              keine Fortschritte sehen, kannst Du die Garantie in Anspruch
              nehmen. Dafür: Lade aktuelle Fotos Deines Hautzustands über Deinen
              Login-Bereich auf unserer Website hoch. Kontaktiere uns per E-Mail
              unter support@formelskin.de, um Dein Anliegen zu schildern. Wir
              prüfen Deine Anfrage und bearbeiten die Rückerstattung innerhalb
              von 7 Werktagen.
            </p>
            <p>
              Wichtige Hinweise: Bestimmte Kosten (9 € pro Behandlungsmonat)
              sind gesetzlich geregelt und nicht erstattungsfähig. Die
              Erstattung ist auf maximal 3 Monatsbeiträge begrenzt. Nach einer
              Rückerstattung ist eine weitere Behandlung ausgeschlossen.
            </p>
          </>
        ),
      },
      {
        icon: sealIcon,
        question:
          "Wann und wie kann ich meine automatische Lieferung kündigen?",
        answer: (
          <>
            <p>
              Du kannst Deine automatische Lieferung jederzeit ganz einfach
              online kündigen. Die Kündigung tritt dann je nach gewählter
              Lieferfrequenz (1-Monats- oder 2-Monats-Set) entweder zum Ende des
              aktuellen oder des nächsten Monats in Kraft.
            </p>
            <p>
              Natürlich ist dies unter Vorbehalt der medizinischen Eignung.
              Solltest Du Probleme mit der Behandlung haben, melde Dich bitte
              bei Deiner FORMEL SKIN-Ärztin bzw. Arzt oder unserem
              Kundenservice, um eine Lösung zu finden.
            </p>
            <p>
              Solltest Du einen Deiner Lieferungszeitpunkte verschieben,
              verlängert oder verkürzt sich Deine Behandlungslaufzeit um die
              gewählte Anpassung.
            </p>
          </>
        ),
      },
    ],
  },
  v2: {
    plans: {
      sub_bimonthly: {
        title: "2-Monats-Set",
        detailsTitle: "Maßgeschneiderte Skincare & ärztliche Betreuung",
        details: [
          {
            content:
              "3-Step-Routine mit fortlaufender ärztlicher Betreuung für sichtbare, dauerhafte Erfolge",
            icon: shineIcon,
          },
          {
            content:
              "Bequeme automatische Lieferung alle 2 Monate (XX € für 2 Monate) ",
            icon: shippingIcon,
          },
        ],
        footnote: "Spare jeden Monat XX €",
      },
      sub_one_month: {
        title: "1-Monats-Set",
        details: [
          {
            content: "Monatliche automatische Lieferung",
          },
          {
            content:
              "Du entscheidest: pausiere, verschiebe, oder kündige jederzeit",
          },
        ],
      },
      single_purchase: {
        title: "Einmalkauf",
        description: "Einmalige Lieferung",
        details: [
          {
            content: "Erhalte einmalig ein personalisiertes FORMEL SKIN-Set",
            icon: checkCircleIcon,
            theme: "primary",
          },
          {
            content: "Keine laufenden Anpassungen Deiner Formel",
            icon: crossCircleIcon,
            theme: "rose",
          },
          {
            content:
              "Keine fortlaufende ärztliche Betreuung zur Verbesserung Deiner Haut",
            icon: crossCircleIcon,
            theme: "rose",
          },
        ],
      },
      prescription: {
        title: "Rezept",
        description: "+ca. 35 € Apothekengebühren",
        details: [
          {
            content:
              "Erhalte ein Privatrezept, keine Zulieferung vom FORMEL SKIN-Set",
            icon: crossCircleIcon,
            theme: "rose",
          },
          {
            content:
              "Keine fortlaufende ärztliche Betreuung & keine Anpassungen Deiner Formel",
            icon: crossCircleIcon,
            theme: "rose",
          },
          {
            content:
              "Ca. 35 € zusätzliche Herstellungskosten in der Apotheke und Wartezeit",
            icon: crossCircleIcon,
            theme: "rose",
          },
        ],
      },
    },
    subscription: {
      title: "Warum FORMEL SKIN?",
      details: [
        "91 % erleben sichtbare Hautverbesserungen",
        "Exklusive Formel – nicht im Handel erhältlich",
        "Risikofrei testen – jederzeit kündbar",
      ],
    },
    faq: [
      {
        icon: refillIcon,
        question: "Wie funktioniert die automatische Lieferung?",
        answer: (
          <>
            <p>
              Deine Haut durchläuft ständig Veränderungen. Daher erhältst Du bei
              unserer automatischen Lieferung (zwei-)monatlich ein neues FORMEL
              SKIN-Set. Zuvor hast Du die Möglichkeit, online einen Check-in
              durchzuführen, bei dem Deine Ärztin/Dein Arzt{" "}
              <span
                sx={{
                  fontWeight: "bold",
                }}
              >
                die Fortschritte Deiner Haut überprüft
              </span>{" "}
              und Deine Formel{" "}
              <span
                sx={{
                  fontWeight: "bold",
                }}
              >
                bei Bedarf anpasst.
              </span>
            </p>
            <p>
              Dir passt der nächste Lieferzeitpunkt nicht? Kein Problem! In
              unserem Kund:innenbereich hast Du die Möglichkeit Deine nächste
              Lieferung auf Deine Bedürfnisse anzupassen.
            </p>
          </>
        ),
      },
      {
        icon: deliveryIcon,
        question: "Für welche Lieferfrequenz soll ich mich entscheiden?",
        answer: (
          <>
            <p>
              Deine Lieferfrequenz kannst Du ganz nach Deiner persönlichen
              Präferenz wählen.
            </p>
            <p>
              Die meisten unserer Patient:innen entscheiden sich für das
              praktische 2-Monats-Set mit dem größten Preisvorteil. Du möchtest
              ebenfalls das beste Preis-Leistungs-Verhältnis und Deine Hautziele
              zu einem möglichst niedrigen Preis erreichen? Dann entscheide auch
              Du Dich für das 2-Monats-Set. Du möchtest maximale Flexibilität?
              Dann wähle das 1-Monats-Set.
            </p>
            <p>
              Egal für welche Option Du Dich entscheidest: Du kannst Deine
              Lieferung jederzeit kündigen, pausieren oder anpassen.
            </p>
          </>
        ),
      },
      {
        icon: euroIcon,
        question: "Wie funktioniert die Geld-zurück-Garantie?",
        answer: (
          <>
            <p>
              Sollte Deine Behandlung keine Fortschritte bringen, bieten wir
              unter bestimmten Bedingungen eine Geld-zurück-Garantie an:
            </p>
            <p>
              Verwendungsdauer: Du hast unsere Akne-Produkte mindestens 60 und
              maximal 90 Tage konsequent angewendet. Ergebnisse sind in der
              Regel nach 6–8 Wochen sichtbar, spätestens jedoch nach 90 Tagen.
            </p>
            <p>
              Anwendung: Du hast die Wirkstoff-Formel regelmäßig und wie
              empfohlen verwendet und mindestens einen ärztlichen Check-in
              wahrgenommen, um gegebenenfalls Anpassungen an der Formel
              vornehmen zu lassen.
            </p>
            <p>
              Solltest Du nach diesem Zeitraum und trotz Anpassungen weiterhin
              keine Fortschritte sehen, kannst Du die Garantie in Anspruch
              nehmen. Dafür: Lade aktuelle Fotos Deines Hautzustands über Deinen
              Login-Bereich auf unserer Website hoch. Kontaktiere uns per E-Mail
              unter support@formelskin.de, um Dein Anliegen zu schildern. Wir
              prüfen Deine Anfrage und bearbeiten die Rückerstattung innerhalb
              von 7 Werktagen.
            </p>
            <p>
              Wichtige Hinweise: Bestimmte Kosten (9 € pro Behandlungsmonat)
              sind gesetzlich geregelt und nicht erstattungsfähig. Die
              Erstattung ist auf maximal 3 Monatsbeiträge begrenzt. Nach einer
              Rückerstattung ist eine weitere Behandlung ausgeschlossen.
            </p>
          </>
        ),
      },
      {
        icon: sealIcon,
        question:
          "Wann und wie kann ich meine automatische Lieferung kündigen?",
        answer: (
          <>
            <p>
              Du kannst Deine automatische Lieferung jederzeit ganz einfach
              online kündigen. Die Kündigung tritt dann je nach gewählter
              Lieferfrequenz (1-Monats- oder 2-Monats-Set) entweder zum Ende des
              aktuellen oder des nächsten Monats in Kraft.
            </p>
            <p>
              Natürlich ist dies unter Vorbehalt der medizinischen Eignung.
              Solltest Du Probleme mit der Behandlung haben, melde Dich bitte
              bei Deiner FORMEL SKIN-Ärztin bzw. Arzt oder unserem
              Kundenservice, um eine Lösung zu finden.
            </p>
            <p>
              Solltest Du einen Deiner Lieferungszeitpunkte verschieben,
              verlängert oder verkürzt sich Deine Behandlungslaufzeit um die
              gewählte Anpassung.
            </p>
          </>
        ),
      },
    ],
  },
}

const { v1: dataV1, v2: dataV2, products } = data

export { dataV1, dataV2, products }
